<template>
  <div>
    <h1 class="title is-2">{{ name }}</h1>

    <p class="subtitle is-5 has-margin-bottom-150">
      <template v-if="showFreeTrial">
        <i18n path="_.free_trial" />
      </template>
      <template v-else>
        {{ $productConfigData.from }}
      </template>
    </p>

    <u-line-clamp class="is-size-7 has-text-grey" :force-open="!truncateDesc">
      <u-markdown>{{ description }}</u-markdown>
    </u-line-clamp>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { BrandConfigKeys } from "@/data/constants";
import type { PropType } from "vue";
import type { IProduct } from "@/models/products";
import type { IProductConfigProviderData } from "@/models/providers/products";

export default defineComponent({
  name: "ProductDetails",
  inject: {
    $productConfigProviderData: {
      from: "productConfigProviderData",
      type: Function as PropType<IProductConfigProviderData>
    }
  },
  props: {
    product: { type: Object as PropType<IProduct>, required: true },
    readMore: { type: Boolean, default: false },
    showFreeTrial: { type: Boolean, default: false }
  },
  computed: {
    $productConfigData() {
      return this.$productConfigProviderData();
    },
    description() {
      return (
        this.product.description_translated ||
        this.product.description ||
        this.product.short_description_translated ||
        this.product.short_description
      );
    },
    truncateDesc() {
      if (this.readMore) return false;
      return (
        this.$store.getters["brand/config"][
          BrandConfigKeys.SHOP_TRUNCATE_DESCRIPTIONS
        ] ?? true
      );
    },
    name() {
      return this.product.name_translated || this.product.name;
    }
  }
});
</script>
